var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Button } from '@cargomatic/ui';
import { Download } from 'lucide-react';
import useSignedUrl from '../../../utils/hooks/useSignedUrl';
/**
 * Button that fetches a signed URL on click and opens it in a new tab.
 *
 * @param {string} documentKey - S3 document key (uses getSignedUrl)
 * @param {string} foreignKey - Entity ID like credit memo _id (uses getSignedUrls)
 * Provide one of documentKey or foreignKey, not both.
 */
const SignedUrlButton = (_a) => {
    var { documentKey, foreignKey, children } = _a, buttonProps = __rest(_a, ["documentKey", "foreignKey", "children"]);
    const { fetchAndOpen, loading } = useSignedUrl();
    const disabled = buttonProps.disabled || loading || (!documentKey && !foreignKey);
    return (React.createElement(Button, Object.assign({ variant: "ghost", size: "icon" }, buttonProps, { disabled: disabled, onClick: () => fetchAndOpen({ documentKey, foreignKey }) }), children || React.createElement(Download, { className: "h-4 w-4" })));
};
export default SignedUrlButton;
